import { FC } from 'react';
import { IDaysLostSeverityMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionBars } from '../../../../shared/charts/DistributionBars';
import { DistributionSlice } from '../../../../shared/charts/chart.types';

interface Props {
  data: IDaysLostSeverityMetric | null;
  period?: string;
  height?: number;
}

const SEVERITY_LABELS: Record<string, string> = {
  slight: 'Lieve',
  minimal: 'Minima',
  mild: 'Mod.lieve',
  moderate: 'Moderata',
  severe: 'Severa',
  'career-ending': 'Fine carr.',
  'da-valutare': 'Da val.',
};

function getSeverityColor(severity: string): string {
  switch (severity) {
    case 'slight':
    case 'minimal':
      return 'var(--ri-good)';
    case 'mild':
    case 'moderate':
      return 'var(--ri-normal)';
    case 'severe':
    case 'career-ending':
      return 'var(--ri-critical)';
    default:
      return 'var(--c-text-3)';
  }
}

export const DaysLostSeverityChart: FC<Props> = ({ data }) => {
  if (!data || !data.buckets || data.buckets.length === 0) {
    return <ChartEmptyState />;
  }

  const totalDays = data.buckets.reduce((sum, b) => sum + b.totalDays, 0);

  const slices: DistributionSlice[] = data.buckets.map((bucket) => ({
    id: bucket.severity,
    label: SEVERITY_LABELS[bucket.severity] ?? bucket.severity,
    value: bucket.totalDays,
    percent: totalDays > 0 ? Math.round((bucket.totalDays / totalDays) * 100) : null,
    color: getSeverityColor(bucket.severity),
  }));

  return (
    <DistributionBars
      data={slices}
      labelMode="value-percent"
      valueFormatter={(v) => `${v} gg`}
      tooltipLabel="Giorni persi"
    />
  );
};
